module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/stronghold_bg.9b4bbcbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/stronghold_bg.jpg
// module id = 3032
// module chunks = 11